import { Box, Typography } from '@mui/material'

import ITestimonialProps from './types'
import {
  TestimonialContainer,
  TestimonialContent,
  TestimonialText,
  ClientInfo,
  Link,
} from './styled'
import Avatar from './Avatar'
import LinkedInIcon from 'components/Icons/LinkedInIcon'
import { useState } from 'react'
import VideoModal from 'components/TestimonialsSection/VideoModal'
import {
  PlayCircleButton,
  WatchVideoContainer,
  WatchVideoTypography,
} from 'components/TestimonialsSection/Content/styled'
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded'

export default function Testimonial({ testimonial }: ITestimonialProps) {
  const [isModalOpen, setModalOpen] = useState(false)

  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleCloseModal = (ref?: React.RefObject<HTMLVideoElement>) => {
    if (ref && ref.current) {
      ref.current.pause()
      ref.current.currentTime = 0
      ref.current.src = ''
    }
    setModalOpen(false)
  }

  return (
    <TestimonialContainer>
      <Avatar
        clientPhoto={testimonial?.clientPhoto?.fullSize}
        imageAltText={testimonial?.clientPhotoAltText}
      />
      <TestimonialContent>
        <TestimonialText>“{testimonial?.text}”</TestimonialText>
        <ClientInfo>
          <Box component="div" display="flex" mb={0.5}>
            <Typography variant="h6" component="p" mr={1.5}>
              {testimonial?.clientName}
            </Typography>
            {testimonial && testimonial?.linkedinUrl && (
              <Link
                href={testimonial?.linkedinUrl}
                target="_blank"
                aria-label={`${testimonial?.clientName}'s Linkedin account`}
                display="flex"
                sx={{ justifyContent: 'center', alignItems: 'center' }}
              >
                <LinkedInIcon />
              </Link>
            )}
          </Box>
          <Typography variant="body2">{testimonial?.clientPosition}</Typography>
          {(testimonial.videoFile || testimonial.embedVideoUrl) && (
            <WatchVideoContainer onClick={() => handleOpenModal()}>
              <PlayCircleButton>
                <PlayArrowRoundedIcon />
              </PlayCircleButton>
              <WatchVideoTypography>Watch Testimonial</WatchVideoTypography>
            </WatchVideoContainer>
          )}
        </ClientInfo>
      </TestimonialContent>

      <VideoModal
        testimonial={testimonial}
        isModalOpen={isModalOpen}
        handleCloseModal={handleCloseModal}
        setModalOpen={setModalOpen}
      />
    </TestimonialContainer>
  )
}
